<template>
    <v-col id="base" md="12" align-self="start" style="height: 100%; max-width: 600px; margin: 0 auto" 
    :style="[$store.state.backImage == null ? { 'background-color': $store.state.colors.primary } : {'background-image': 'url(' + $store.state.backImage + ')'}]" 
    class="mt-0 pt-0 ">
        <v-row justify="center" align="start" style="height: 100%">
          <v-col style="height: 100%">

            <v-row justify="center" align="center" style="height:90%">
              <transition appear name="slide-fade">
                  <!-- <v-img :src="require('@/assets/resources/logos_white/' + this.$store.state.codigo_marca + '.svg')" contain height="300px" max-width="80%" v-if="logo"></v-img> -->
                  <v-img :src="$store.state.logoSRC" contain height="300px" max-width="80%" v-if="logo"></v-img>
              </transition>
            </v-row>

            <v-row justify="center" style="height:10%; ">
              <v-col align-self="center">
                
                  <v-row justify="end" class="RestoBold" style="font-size: 13px">
                    <transition appear name="slide-fade">
                      <p>Powered by:</p>
                    </transition>
                  </v-row>
                
              </v-col>
              <v-col cols="auto" align-self="center">
                <transition appear name="slide-fade">
                    <v-img src="@/assets/resources/yoomi/yoomy-blanco.png" contain  max-width="150px" v-if="logo && $store.state.backImage == null"></v-img>
                    <v-img src="@/assets/resources/yoomi/yoomy-negro.png" contain  max-width="150px" v-if="$store.state.backImage != null"></v-img>
                </transition>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    data () {
      return {
          logo: false,
      }
    },

    mounted() {
        this.logo = true;
        setTimeout(() => {  this.$router.push({ name: 'verification'}); }, 4000);
    }
    
    
}
</script>

<style scoped>
  .slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>